import $ from 'jquery';
import log from 'log';

$.fn.triggerSafe = function (event, params) {
    try {
        return this.triggerHandler(event, params);
    } catch(e) {
        log('Exception in handler for event: ' + event + '\n' + e.stack);
    }
};
